
      <ul>

          <!--  PARENT LOOP  -->

          <li *ngFor="let navItem of navItems" [class.parent]="navItem.children" [class.expanded]="navItem.expanded" [routerLinkActive]="'active'">

              <!--  ITEM WITH NO CHILDREN  -->

              <a *ngIf="!navItem.children" class="pri-hl-col" [class.has-prefix]="navItem.prefix" [routerLink]="['/' + parentPath, navItem.path]" [routerLinkActive]="'acc-hl-br'" (click)="onNavigation()">
                  <span class="prefix">{{ navItem.prefix }}</span>{{ navItem.name }}
              </a>

              <!--  END ITEM WITH NO CHILDREN  -->

              <!--  PARENT WITH ACTIVE CHILD - NOT EXPANDED  -->

              <a *ngIf="navItem.children" class="is-active pri-hl-col acc-hl-br" [class.has-prefix]="navItem.prefix" (click)="navItem.expanded = !navItem.expanded">
                  <i class="fas fa-chevron-right acc-hl-col"></i>
                  <span class="prefix">{{ navItem.prefix }}</span>{{ navItem.name }}
              </a>

              <!-- END PARENT WITH ACTIVE CHILD - NOT EXPANDED  -->

              <!--  PARENT WITH ACTIVE CHILD - EXPANDED  -->

              <a *ngIf="navItem.children" class="is-inactive pri-hl-col" [class.has-prefix]="navItem.prefix" (click)="navItem.expanded = !navItem.expanded">
                  <i class="fas fa-chevron-right acc-hl-col"></i>
                  <span class="prefix">{{ navItem.prefix }}</span>{{ navItem.name }}
              </a>

              <!--  END PARENT WITH ACTIVE CHILD - EXPANDED  -->

              <!--  CHILD ITEMS  -->

              <ul *ngIf="navItem.children">

                  <!--  CHILD ITEM LOOP  -->

                  <li *ngFor="let subNavItem of navItem.children" [routerLinkActive]="'active'">
                      <a class="pri-hl-mix-col" [routerLink]="['/' +  parentPath, navItem.path, subNavItem.path]" [routerLinkActive]="'acc-hl-br pri-hl-col'" (click)="onNavigation()">
                          {{ subNavItem.name }}
                      </a>
                  </li>

                  <!--  END CHILD ITEM LOOP  -->

              </ul>

              <!--  END CHILD ITEMS  -->

          </li>

          <!--  END PARENT LOOP  -->

      </ul>
    